import React from "react";

const BookingIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 21.143 18.4795"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.1862,1.8796c0,-0.378 -0.301,-0.68 -0.6796,-0.68h-13.8604c-0.3768,0 -0.6838,0.302 -0.6895,0.688v12.096l-0.0742,0.135l-1.6699,3.04c-0.0299,0.058 0.0083,0.121 0.0742,0.121h18.5694c0.0659,0 0.1041,-0.063 0.0742,-0.121l-1.6699,-3.04l-0.0743,-0.135zM19.3864,13.6756l1.5957,2.905l0.002,0.002l0.0752,0.163c0.3139,0.824 -0.2906,1.734 -1.2031,1.734h-18.5694c-0.9732,0 -1.5959,-1.035 -1.1279,-1.897l0.0019,-0.002l1.5958,-2.905v-11.805l0.0117,-0.191c0.1073,-0.943 0.9003,-1.679 1.8779,-1.68h13.8604c1.0413,0 1.8798,0.839 1.8798,1.88z"
        fill="currentColor"
      />
      <path
        d="M13.083,7.0696c0,-1.24 -0.9765,-2.261 -2.2279,-2.384l-0.2535,-0.012c-1.3705,0 -2.4814,1.073 -2.4814,2.396c0.0002,1.323 1.1112,2.396 2.4814,2.396v1.104c-2.002,0 -3.6248,-1.567 -3.625,-3.5c0,-1.933 1.6229,-3.5 3.625,-3.5c2.0019,0 3.625,1.567 3.625,3.5c-0.0002,1.933 -1.6232,3.5 -3.625,3.5v-1.104c1.2847,0 2.342,-0.943 2.4692,-2.151z"
        fill="currentColor"
      />
      <path
        d="M13.0348,10.5696c-0.7654,0.263 -1.5879,0.407 -2.4332,0.407c-0.8453,0 -1.6678,-0.144 -2.4332,-0.407l-0.2856,0.885c0,0 0.5598,0.132 1.0853,0.598c0.4683,0.407 0.7539,0.873 0.8453,1.507c0.0343,0.264 0.1485,1.328 0.2056,2.01h1.1652c0.0685,-0.694 0.1713,-1.758 0.2056,-2.01c0.0914,-0.634 0.3884,-1.1 0.8453,-1.507c0.5255,-0.466 1.0853,-0.598 1.0853,-0.598z"
        fill="#1A8B5A"
      />
      <path
        d="M7.6134,18.0996v-0.68c0,-0.457 0.4725,-0.82 1.0394,-0.82h3.9094c0.5788,0 1.0394,0.373 1.0394,0.82v0.68h-6z"
        fill="#1A8B5A"
      />
    </svg>
  );
};

export default BookingIcon;
